import React from 'react';
import PropTypes from 'prop-types';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';
import { SearchResultEntity } from './search-result-entity';

class SearchResult extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isSelected: PropTypes.bool,
    getItemProps: PropTypes.func.isRequired,
  };

  // Use default <a href> behavior instead of Downshift click handler.
  onClick = (e) => {
    e.nativeEvent.preventDownshiftDefault = true;
  };

  render() {
    const { index, item, isSelected, getItemProps, searchPhrase } = this.props;

    return (
      <CommonChrome.NavSearch.Result
        selected={isSelected}
        {...getItemProps({
          index,
          item: { item, index },
          onClick: this.onClick,
        })}
      >
        <SearchResultEntity item={item} searchPhrase={searchPhrase} />
      </CommonChrome.NavSearch.Result>
    );
  }
}

export default SearchResult;
